import { css } from "@emotion/css";
import { Yellow } from "@snapchat/snap-design-system/es/constants/colors";

export const appHeaderStyle = css`
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.06);

    &:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 3px;
        background-color: ${Yellow.V200};
    }
`;

export const appLinkStyle = css`
    color: #61dafb;
`;

export const routeContainer = css`
    position: relative;
    padding: 0 32px;
    display: flex;
    flex: 1 1 0%;
    height: calc((100vh - 56px) - 1px);
    min-height: calc((100vh - 56px) - 1px);
    justify-content: center;
    overflow-y: auto;
`;

export const routeDetails = css`
    overflow: hidden;
    display: flex;
    flex-direction: column;
`;

export const routeFlexItem = css`
    max-width: 1200px;
    flex: 1 1 0%;
`;
